
































import { Component, Vue } from 'vue-property-decorator';
import { readIsLoggedIn } from '@/store/main/getters';
import {dispatchCheckLoggedIn, dispatchLogInByToken} from '@/store/main/actions';
import Cookies from 'js-cookie';

@Component
export default class App extends Vue {
  public deferredPrompt = false;

  get loggedIn() {
    return readIsLoggedIn(this.$store);
  }
  public async mounted() {
    await dispatchCheckLoggedIn(this.$store);
  }
  public async created() {

    if (Cookies.get('add-to-home-screen') === undefined) {
      const isIos = () => {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test( userAgent );
      };

      // @ts-ignore
      const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

      if (isIos() && !isInStandaloneMode()) {
        this.deferredPrompt = true;
      }
    }

    // window.addEventListener('beforeinstallprompt', (e) => {
    //   console.log('beforeinstallprompt event');
    //   e.preventDefault();
    //   if (Cookies.get('add-to-home-screen') === undefined) {
    //     console.log('cookie not exist');
    //     this.deferredPrompt = e;
    //   }
    //   console.log('after cookie');
    // });
    // window.addEventListener('appinstalled', () => {
    //   this.deferredPrompt = null;
    // });
  }
  public async dismissPWA() {
    Cookies.set('add-to-home-screen', 1, { expires: 90 });
    this.deferredPrompt = false;
  }
  // async installPWA() {
  //   this.deferredPrompt.prompt();
  // },
}
